import { render, staticRenderFns } from "./AdministratorNotice.vue?vue&type=template&id=9bb03f8c&scoped=true&"
import script from "./AdministratorNotice.vue?vue&type=script&lang=js&"
export * from "./AdministratorNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb03f8c",
  null
  
)

export default component.exports